import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CBadge, CButton, CCollapse, CFormSwitch } from '@coreui/react';
import { setConsent } from 'src/utils/cookieConsent';

const CookieBanner = ({ onConsent, initialConsent }) => {
  const { t } = useTranslation();
  const [showManage, setShowManage] = useState(!!initialConsent);
  const [analytics, setAnalytics] = useState(initialConsent?.analytics ?? false);
  const [support, setSupport] = useState(initialConsent?.support ?? false);

  const handleAcceptAll = () => {
    onConsent(setConsent({ analytics: true, support: true }));
  };

  const handleRejectAll = () => {
    onConsent(setConsent({ analytics: false, support: false }));
  };

  const handleSavePreferences = () => {
    onConsent(setConsent({ analytics, support }));
  };

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        backgroundColor: 'var(--cui-body-bg)',
        borderTop: '1px solid var(--cui-border-color)',
        padding: '1rem 1.5rem',
        boxShadow: '0 -4px 16px rgba(0,0,0,0.08)',
      }}
    >
      <div className="d-flex flex-column flex-md-row align-items-md-center gap-3">
        <div style={{ flex: 1 }}>
          <strong>{t('cookie.title')}</strong>
          <p className="mb-0 mt-1" style={{ fontSize: '0.875rem', color: 'var(--cui-secondary-color)' }}>
            {t('cookie.description')}
          </p>
        </div>
        <div className="d-flex gap-2 flex-shrink-0">
          <CButton size="sm" color="link" onClick={() => setShowManage(!showManage)}>
            {t('cookie.manage')}
          </CButton>
          <CButton size="sm" color="secondary" variant="outline" onClick={handleRejectAll}>
            {t('cookie.rejectAll')}
          </CButton>
          <CButton size="sm" color="primary" onClick={handleAcceptAll}>
            {t('cookie.acceptAll')}
          </CButton>
        </div>
      </div>

      <CCollapse visible={showManage}>
        <div className="mt-3 pt-3" style={{ borderTop: '1px solid var(--cui-border-color)' }}>
          <div className="d-flex flex-column gap-3">
            <div className="d-flex align-items-center justify-content-between gap-3">
              <div>
                <div className="fw-semibold">{t('cookie.necessary.title')}</div>
                <div style={{ fontSize: '0.8125rem', color: 'var(--cui-secondary-color)' }}>
                  {t('cookie.necessary.description')}
                </div>
              </div>
              <CBadge color="success" className="flex-shrink-0">{t('cookie.alwaysActive')}</CBadge>
            </div>

            <div className="d-flex align-items-center justify-content-between gap-3">
              <div>
                <div className="fw-semibold">{t('cookie.analytics.title')}</div>
                <div style={{ fontSize: '0.8125rem', color: 'var(--cui-secondary-color)' }}>
                  {t('cookie.analytics.description')}
                </div>
              </div>
              <CFormSwitch
                checked={analytics}
                onChange={(e) => setAnalytics(e.target.checked)}
                aria-label={t('cookie.analytics.title')}
                className="flex-shrink-0"
              />
            </div>

            <div className="d-flex align-items-center justify-content-between gap-3">
              <div>
                <div className="fw-semibold">{t('cookie.support.title')}</div>
                <div style={{ fontSize: '0.8125rem', color: 'var(--cui-secondary-color)' }}>
                  {t('cookie.support.description')}
                </div>
              </div>
              <CFormSwitch
                checked={support}
                onChange={(e) => setSupport(e.target.checked)}
                aria-label={t('cookie.support.title')}
                className="flex-shrink-0"
              />
            </div>
          </div>

          <div className="d-flex justify-content-end mt-3">
            <CButton size="sm" color="primary" onClick={handleSavePreferences}>
              {t('cookie.savePreferences')}
            </CButton>
          </div>
        </div>
      </CCollapse>
    </div>
  );
};

export default CookieBanner;
